export default "__VITE_ASSET__DxsjYADH__"